export type RoomType = {
  type_key: string;
  display_name: string;
  allow_multiple: boolean;
};

export const ROOM_TYPES: RoomType[] = [
  { type_key: 'kitchen', display_name: 'Kitchen', allow_multiple: false },
  { type_key: 'living_room', display_name: 'Living Room', allow_multiple: false },
  { type_key: 'dining_room', display_name: 'Dining Room', allow_multiple: false },
  { type_key: 'bedroom', display_name: 'Bedroom', allow_multiple: true },
  // A child's own room (2026-10-15): the setup makes one per child, and their own tasks go there.
  { type_key: 'child_bedroom', display_name: 'Child Bedroom', allow_multiple: true },
  { type_key: 'bathroom', display_name: 'Bathroom', allow_multiple: true },
  { type_key: 'toilet', display_name: 'Toilet', allow_multiple: true },
  { type_key: 'hallway', display_name: 'Hallway', allow_multiple: false },
  { type_key: 'entryway', display_name: 'Entryway', allow_multiple: false },
  { type_key: 'laundry_room', display_name: 'Laundry Room', allow_multiple: false },
  { type_key: 'garage', display_name: 'Garage', allow_multiple: true },
  { type_key: 'office', display_name: 'Office', allow_multiple: true },
  { type_key: 'playroom', display_name: 'Playroom', allow_multiple: true },
  { type_key: 'nursery', display_name: 'Nursery', allow_multiple: true },
  { type_key: 'patio', display_name: 'Patio/Balcony', allow_multiple: true },
  { type_key: 'garden', display_name: 'Garden', allow_multiple: true },
  { type_key: 'storage', display_name: 'Storage', allow_multiple: true },
  { type_key: 'basement', display_name: 'Basement', allow_multiple: true },
  { type_key: 'attic', display_name: 'Attic', allow_multiple: true },
];

export function generateAutoLabel(baseName: string, count: number): string {
  return count > 1 ? `${baseName} ${count}` : baseName;
}


